module.exports = __webpack_public_path__ + "static/media/793.b0740274.webp";